import React, { Component } from "react";
import { connect } from "react-redux";
import { sendActionToDevice } from "../redux/actions/deviceActions";
import { SUPER_ADMIN } from "../utils/userRoles";
import { DeviceCommandsDialog } from "../dialogs/DeviceCommandsDialog";
import { extractAvaliableAppOptions, extractAppsApprovedByBundles } from "../utils/deviceGroupUtils";
import { sendLaunchAppCommandToDevice } from "../redux/actions/deviceActions";
import { editDeviceGroupKioskApp } from "../redux/actions/deviceGroupActions";

export class DeviceCommands extends Component {
  state = {
    apps: [],
    selectedApp: "",
    actions: {},
    selectedAction: {},
    setAppAsKioskApp: false
  };

  componentDidMount() {
    this.generateActions();
    const apps = this.getAppsOptions();
    let selectedApp = "";
    if (apps[0]) selectedApp = apps[0].value;
    this.setState({ apps, selectedApp });
  }

  sendAction = () => {
    const { actions, selectedAction } = this.state;
    const action = actions[selectedAction].action;

    const { commandsProps: { deviceKeys, forGroup, title }, sendActionToDevice } = this.props;

    let message = "";
    if (forGroup) message = action + " command sent to device group [" + title + "]";
    else message = action + " command sent to device [" + title + "]";

    if (deviceKeys) deviceKeys.map(deviceKey => sendActionToDevice({ action, deviceKey, message }));
  };

  sendLaunchAction = () => {
    const { commandsProps: { deviceKeys, forGroup, title, deviceGroupKey }, sendLaunchAppCommandToDevice, editDeviceGroupKioskApp, apps } = this.props;
    const { selectedApp, setAppAsKioskApp } = this.state;
    const app = apps[selectedApp];

    let message = "";
    if (forGroup) message = "Launch App [" + app.title + "] command sent to device group [" + title + "]";
    else message = "Launch App [" + app.title + "] command sent to device [" + title + "]";

    if (deviceKeys) {
      if (!!apps) {
        deviceKeys.map(deviceKey => sendLaunchAppCommandToDevice({ deviceKey, packageName: app.packageName, message }));
      }
      if (setAppAsKioskApp) {
        editDeviceGroupKioskApp({ key: deviceGroupKey, kioskAppKey: selectedApp });
      }
    }
  }

  generateActions = () => {
    const { currentUser } = this.props;

    let actions = {
      onChekIn: {
        title: "Check-In",
        action: "CHECK_IN"
      },
      onLaunchApp: {
        title: "Launch App"
      },
      onEnableKiosk: {
        title: "Enable Kiosk Mode",
        action: "ENABLE_KIOSK"
      },
      onDisableKiosk: {
        title: "Disable Kiosk Mode",
        action: "DISABLE_KIOSK"
      },
      onResetFirstTimeUseMode: {
        title: "Reset First Time Use Mode",
        action: "RESET_FIRST_TIME_USE"
      },
      onRestart: {
        title: "Restart",
        action: "RESTART"
      }
    };

    if (currentUser && currentUser.role === SUPER_ADMIN)
      actions.onSendCrashlytics = {
        title: "Send Crashlytics Logs",
        action: "SEND_CRASHLYTICS"
      };

    this.setState({ actions, selectedAction: "onChekIn" })
  }

  getAppsOptions = () => {
    const { commandsProps: { deviceGroupKey }, deviceGroups, apps, contentBundles } = this.props;
    const { approvedApps, contentBundleRefs } = deviceGroups[deviceGroupKey];
    const selectedBundleKeys = [];
    if (contentBundleRefs) {
      contentBundleRefs.map(s => selectedBundleKeys.push(s.id));
    }
    const appsApprovedByBundles = extractAppsApprovedByBundles({ contentBundles, selectedBundleKeys });
    const selectedApps = [];
    if (approvedApps) approvedApps.map(s => selectedApps.push({ key: s.id }));
    return extractAvaliableAppOptions({ appsApprovedByBundles, apps, selectedApps });
  }

  onSend = () => {
    const { selectedAction } = this.state;
    if (selectedAction == "onLaunchApp") this.sendLaunchAction();
    else this.sendAction();
  }

  render() {
    const { actions, selectedAction, apps, selectedApp } = this.state;
    const { commandsProps: { title, forGroup }, onClose } = this.props;
    return (
      <div>
        <DeviceCommandsDialog
          onClose={onClose}
          actions={actions}
          selectedAction={selectedAction}
          onActionChange={selectedAction => this.setState({ selectedAction })}
          apps={apps}
          selectedApp={selectedApp}
          onAppChange={selectedApp => this.setState({ selectedApp })}
          showLaunchApp={selectedAction == "onLaunchApp"}
          showSetKioskApp={forGroup}
          onKioskChange={setAppAsKioskApp => this.setState({ setAppAsKioskApp })}
          dialogTitle={title}
          onSend={this.onSend}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.user.user,
  deviceGroups: state.data.deviceGroups,
  apps: state.data.apps,
  contentBundles: state.data.contentBundles
});

const mapDispatchToProps = {
  sendActionToDevice,
  sendLaunchAppCommandToDevice,
  editDeviceGroupKioskApp
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceCommands);
